import { TBannerTypes } from '../../../types/newbuildingBanners/banners';

export type TBannerTheme =
  | 'brand-pink'
  | 'primary-default'
  | 'primary-accent'
  | 'brand-peach'
  | 'gradient-linear-primary-brand-pink';

const typeToThemeDefaultSet: Record<TBannerTypes, TBannerTheme> = {
  allPromos: 'primary-accent',
  topPromos: 'brand-peach',
  lastChanceDiscount: 'brand-pink',
  newbuildingBroker: 'primary-default',
};

export const bannerTypeToDefaultTheme = ({ type }: { type: TBannerTypes }) => {
  return typeToThemeDefaultSet[type];
};
